import { put, takeLatest } from "redux-saga/effects";
import {
  requestMarketingLeadList,
  requestMarketingKpi,
  requestPromoteMarketingLead,
} from "services/MarketingLead";
import {
  fetchMarketingLeadListFailure,
  fetchMarketingLeadListRequest,
  fetchMarketingLeadListSuccess,
  fetchMarketingKpiFailure,
  fetchMarketingKpiRequest,
  fetchMarketingKpiSuccess,
  promoteMarketingLeadFailure,
  promoteMarketingLeadRequest,
  promoteMarketingLeadSuccess,
} from "redux/reducers/marketingLead";

export function* watchMarketingLeadSaga() {
  yield takeLatest(fetchMarketingLeadListRequest.type, fetchMarketingList);
  yield takeLatest(fetchMarketingKpiRequest.type, fetchMarketingKpi);
  yield takeLatest(promoteMarketingLeadRequest.type, promoteMarketing);
}

function* fetchMarketingList(action) {
  try {
    const queryString = action.payload;
    const response = yield requestMarketingLeadList(queryString);
    yield put(fetchMarketingLeadListSuccess(response));
  } catch (e) {
    yield put(fetchMarketingLeadListFailure(e?.message || "Failed to load marketing leads"));
  }
}

function* fetchMarketingKpi(action) {
  try {
    const queryString = action.payload;
    const response = yield requestMarketingKpi(queryString);
    yield put(fetchMarketingKpiSuccess(response));
  } catch (e) {
    yield put(fetchMarketingKpiFailure(e?.message || "Failed to load KPIs"));
  }
}

function* promoteMarketing(action) {
  try {
    const { id, body } = action.payload || {};
    const response = yield requestPromoteMarketingLead(id, body);
    yield put(promoteMarketingLeadSuccess(response));
  } catch (e) {
    yield put(promoteMarketingLeadFailure(e?.message || "Promote failed"));
  }
}
